<!-- //
Layout
@auth xuyd
@date 2024-05-01
//-->
<template>
  <!-- 详情页面 -->
  <el-container v-if="isC" class="layout">
    <el-main class="layout-main">
      <slot/>
    </el-main>
  </el-container>

  <!-- 详情页面 -->
  <el-container v-else-if="isCB" class="layout">
    <el-main class="layout-main">
      <slot/>
    </el-main>
    <el-footer class="layout-footer">
      <slot name="pageFooter"/>
    </el-footer>
  </el-container>

  <!-- 详情页面带有侧边树等 -->
  <el-container v-else-if="isAC" class="layout">
    <el-aside class="layout-aside">
      <slot name="pageAside"/>
    </el-aside>
    <el-main class="layout-main" style="margin-left: 2px;">
      <slot/>
    </el-main>
  </el-container>

  <!-- 详情页面带有侧边树等 -->
  <el-container v-else-if="isSAC" class="layout flex-column">
    <el-header class="header">
      <slot name="pageSearch"/>
    </el-header>
    <el-container style="height: calc(100% - 63px);">
      <el-aside class="layout-aside">
        <slot name="pageAside"/>
      </el-aside>
      <el-main class="layout-main" style="margin-left: 2px;">
        <slot/>
      </el-main>
    </el-container>
  </el-container>
  <!-- 详情页面带有侧边树等 -->
  <el-container v-else-if="isACB" class="layout">
    <el-container style="height: 100%">
      <el-aside class="layout-aside">
        <slot name="pageAside"/>
      </el-aside>
      <el-main class="layout-main" style="margin-left: 2px;">
        <slot/>
      </el-main>
    </el-container>
    <el-footer class="layout-footer">
      <slot name="pageFooter"/>
    </el-footer>
  </el-container>

  <!-- 工作流详情拖拽页面 -->
  <el-container v-else>
    <el-main class="custom-layout">
      <slot/>
    </el-main>
  </el-container>
</template>
<script>

export default {
  name: 'PageLayout',
  data() {
    return {}
  },
  computed: {
    isC() {// 只有中间一块，列表，首页
      return this.layout === 'C'
    },
    isCB() {// 上下，详情
      return this.layout === 'C|B'
    },
    isAC() {
      return this.layout === 'A|C'
    },
    isSAC() {// 上search，(左aside，右center)
      return this.layout === 'S|AC'
    },
    isACB() {// (左右)下
      return this.layout === 'AC|B'
    },
  },
  props: {
    layout: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.custom-layout {
  padding: 0;
  margin: 0;
  height: 100%;
}

.layout {
  padding: 0 0 0 10px !important;
  margin: 0 !important;
  height: 100%;

  .header {
    padding: 0;
    height: auto !important;
  }
}

.el-main {
  margin: 0;
  padding: 0;
}
.layout-aside {
  width: auto!important;
  height: 100% ;
  padding: 10px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.layout-main {
  min-width: 824px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
